import FlexPane from './_flex-pane.js'
import EventCardsCarousel from './_event-cards-carousel.js'
import PrebuiltPromotionCards from './_prebuilt-promotion-cards.js'
import MenuLinkPromotions from './_menu-link-promotions.js'
import SportGroupsListController from './_sport-groups-list-controller.js'

export default {
  name: 'CompetitionsView',
  values: {
    container: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '16px',
        style: {
          padding: '16px 0 0 0',
          flexDirection: 'column',
        },
      },
    },
    eventCardsCarousel: {
      configSet: EventCardsCarousel,
      configValues: {},
    },
    prebuiltPromotionCards: {
      configSet: PrebuiltPromotionCards,
      configValues: {},
    },
    showFeaturedLinks: true,
    menuLinkPromotions: {
      configSet: MenuLinkPromotions,
      configValues: {
        extraLinksInFront: true,
        menuRow: {
          style: {
            container: {
              justifyContent: 'left',
            },
          },
          buttonScrollPane: {
            contentContainer: {
              itemSpacing: '8px',
            },
            scrollPaneContainer: {
              style: {
                flexGrow: 0,
              },
            },
            leftScrollButtonContainer: {
              style: {
                left: '-4px',
              },
            },
          },
          itemInnerContainer: {
            style: {
              padding: '0 16px',
            },
          },
        },
      },
    },
    topLeagues: {
      configSet: SportGroupsListController,
      configValues: {},
    },
    allLeagues: {
      configSet: SportGroupsListController,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
